import { FC } from "react";
import styled, { css } from "styled-components";
import Unit, { formatUnit } from "../types/Unit";
import theme from "../theme";

type Align = "left" | "center" | "right";

const Container = styled.div`
  position: relative;
`;

const Label = styled.div<{ $align: Align }>`
  position: absolute;
  top: 15px;
  display: inline-block;
  color: #444444;
  text-align: right;
  height: 40px;
  user-select: none;
  font-size: ${theme.fontSize.small};
  white-space: nowrap;
  @media screen and (min-width: 800px) {
    font-size: ${theme.fontSize.normal};
  }
  ${({ $align }) =>
    $align === "left"
      ? css`
          right: 0;
        `
      : $align === "right"
      ? css`
          left: 0;
        `
      : css`
          transform: translateX(-50%);
        `}
`;

interface SliderMarkerLabelProps {
  value: number;
  unit: Unit;
  align: Align;
}

const SliderMarkerLabel: FC<SliderMarkerLabelProps> = ({
  value,
  align = "center",
  unit,
}) => (
  <Container>
    <Label $align={align}>{formatUnit(value, unit)}</Label>
  </Container>
);

export default SliderMarkerLabel;
